import { useEffect } from 'react';
import XLRLogger from 'src/common/helpers/logger';
import { sleep } from 'src/common/helpers/sleep';

export const useFastLogin = (loginProcess): null => {
  useEffect((): void => {
    const {
      REACT_APP_FAST_LOGIN,
      REACT_APP_FAST_LOGIN_USERNAME: userName,
      REACT_APP_FAST_LOGIN_PASSWORD: password,
    } = process.env;
    if (REACT_APP_FAST_LOGIN?.toLowerCase() === 'true' && !window.Cypress) {
      XLRLogger.info({
        message: 'Using fast login',
        source: 'useFastLogin.ts',
      });
      const handleLoginProcess = async (): Promise<void> => {
        await sleep(1);
        loginProcess({ userName, password });
      };
      handleLoginProcess();
    }
  }, [loginProcess]);
  return null;
};
